import React, { useState, useEffect } from 'react';
import './Landing.css';
import Sidebar from '../../components/Sidebar/Sidebar';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/images/seedxpert-light.png';

const Landing = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  // Sayfa yüklendiğinde scroll'u en üste al
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const features = [
    {
      icon: '📊',
      title: t('landing.feature1Title'),
      description: t('landing.feature1Desc'),
      color: '#10b981'
    },
    {
      icon: '⚡',
      title: t('landing.feature2Title'),
      description: t('landing.feature2Desc'),
      color: '#10b981'
    },
    {
      icon: '🎯',
      title: t('landing.feature3Title'),
      description: t('landing.feature3Desc'),
      color: '#10b981'
    },
    {
      icon: '📈',
      title: t('landing.feature4Title'),
      description: t('landing.feature4Desc'),
      color: '#10b981'
    },
    {
      icon: '💼',
      title: t('landing.feature5Title'),
      description: t('landing.feature5Desc'),
      color: '#10b981'
    },
    {
      icon: '🔒',
      title: t('landing.feature6Title'),
      description: t('landing.feature6Desc'),
      color: '#10b981'
    }
  ];

  const stats = [
    { number: '10+', label: t('landing.experienceYears') },
    { number: '7/24', label: t('landing.support') },
    { number: '24/7', label: t('landing.platformAccess') }
  ];

  const steps = [
    {
      number: '01',
      title: t('landing.step1Title'),
      description: t('landing.step1Desc')
    },
    {
      number: '02',
      title: t('landing.step2Title'),
      description: t('landing.step2Desc')
    },
    {
      number: '03',
      title: t('landing.step3Title'),
      description: t('landing.step3Desc')
    }
  ];

  return (
    <div className="new-landing-container">
      <Sidebar />

      <div className="new-landing-content">
        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-background">
            <div className="gradient-orb orb-1"></div>
            <div className="gradient-orb orb-2"></div>
            <div className="gradient-orb orb-3"></div>
          </div>

          <div className="hero-content">
            <div style={{ minHeight: '95vh' }}>
              <div className="hero-badge">
                <span className="badge-icon">✨</span>
                <span>{t('landing.welcomeBadge')}</span>
              </div>

              <h1 className="hero-title">
                {t('landing.heroMainTitle')}
                <span className="gradient-text"> {t('landing.heroMainTitleGradient')}</span>
              </h1>

              <p className="hero-description">
                {t('landing.heroDesc')}
              </p>

              <div className="hero-buttons">
                <Link to="/entrepreneur-info" className="primary-hero-btn">
                  <span>{t('landing.createReport')}</span>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </Link>
                <Link to="/shop" className="secondary-hero-btn">
                  <span>{t('landing.viewPackages')}</span>
                </Link>
              </div>

              <div className="hero-stats">
                {stats.map((stat, index) => (
                  <div key={index} className="stat-item">
                    <div className="stat-number">{stat.number}</div>
                    <div className="stat-label">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
            {/* Features Section */}
            <div className="section-header-landing">
              <span className="section-badge">{t('landing.featuresBadge')}</span>
              <h2 className="section-title">{t('landing.whySeedxpert')}</h2>
              <p className="section-description">
                {t('landing.featuresDesc')}
              </p>
            </div>

            <div className="features-grid">
              {features.map((feature, index) => (
                <div key={index} className="feature-card" style={{ '--feature-color': feature.color }}>
                  <div className="feature-icon-wrapper">
                    <span className="feature-icon">{feature.icon}</span>
                  </div>
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="cta-background">
            <div className="cta-orb cta-orb-1"></div>
            <div className="cta-orb cta-orb-2"></div>
          </div>

          <div className="cta-content">
            <h2 className="cta-title">
              {t('landing.ctaTitle')}
              <span className="gradient-text"> {t('landing.ctaTitleGradient')}</span>
            </h2>
            <p className="cta-description">
              {t('landing.ctaDesc')}
            </p>
            <div className="cta-buttons">
              <Link to="/entrepreneur-info" className="cta-primary-btn">
                {t('landing.getStartedNow')}
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </Link>
              <Link to="/shop" className="cta-secondary-btn">
                {t('landing.viewPackagesBtn')}
              </Link>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Landing;